import React, { useCallback, useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import {
  Box,
  BoxProps,
  Button,
  Dialog,
  DialogContent,
  FormGroup,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ReactMarkDown from "react-markdown";

interface Props {
  open: boolean;
  imageStr: string;
  urlStr: string;
  onCancel: () => void;
  onOk: () => void;
  handleDownloadImage: (imageUrl: string) => void;
}

const BaseDialog = (props: Props) => {
  const { open, onCancel: onCancel, onOk: onOk } = props;
  const [checkedTerm, setCheckedTerm] = useState(false);
  const [checkedMinor, setCheckedMinor] = useState(false);
  const imageStrRef = useRef<string>("");
  const checkLabelTermAgree: string = "利用規約に同意して利用します";
  const checkLabelMinor: string =
    "18歳未満の場合は保護者に確認を得てから利用することに同意します";
  const BoxWrapper = styled(Box)<BoxProps>(({ theme }) => ({
    [theme.breakpoints.down("md")]: {
      maxWidth: "90vw",
    },
  }));
  const onCheckTermAgree = () => {
    setCheckedTerm(!checkedTerm);
  };
  const onCheckMinor = () => {
    setCheckedMinor(!checkedMinor);
  };
  const handleDownloadImageWrapper = useCallback(() => {
    props.handleDownloadImage(props.imageStr);
  }, []);

  return (
    <Dialog
      maxWidth={false}
      open={open}
      sx={{
        "& .MuiDialog-paper": {
          width: "90%",
          maxWidth: "90vw",
          marginLeft: "5vw",
          marginRight: "5vw",
        },
      }}
    >
      <DialogContent
        sx={{
          margin: "auto",
          paddingTop: "5vw",
          paddingBottom: "5vw",
          paddingLeft: "0",
          paddingRight: "0",
          overflowY: "auto",
          maxHeight: "80vh",
        }}
      >
        <BoxWrapper>
          <Box sx={{ mb: 2, textAlign: "center" }}>
            {props.urlStr ? (
              <div
                style={{
                  fontSize: "0.8rem",
                  textAlign: "left",
                  marginLeft: "1rem",
                  marginRight: "1rem",
                }}
              >
                <ReactMarkDown>{props.urlStr}</ReactMarkDown>
                <FormGroup>
                  <FormControlLabel
                    required
                    control={
                      <Checkbox
                        checked={checkedTerm}
                        onChange={onCheckTermAgree}
                      />
                    }
                    label={
                      <Typography style={{ fontSize: "0.8rem" }}>
                        {checkLabelTermAgree}
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    required
                    control={
                      <Checkbox
                        checked={checkedMinor}
                        onChange={onCheckMinor}
                      />
                    }
                    label={
                      <Typography style={{ fontSize: "0.8rem" }}>
                        {checkLabelMinor}
                      </Typography>
                    }
                  />
                </FormGroup>
              </div>
            ) : props.imageStr ? (
              <img
                src={props.imageStr}
                alt=""
                style={{
                  width: "80vw",
                }}
              />
            ) : null}
          </Box>
          {props.urlStr ? (
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              gap={1}
            >
              <Button
                disabled={!checkedTerm || !checkedMinor}
                size="small"
                type="submit"
                variant="contained"
                onClick={() => onOk()}
                sx={{ mb: 2 }}
              >
                はじめる
              </Button>
            </Grid>
          ) : props.imageStr ? (
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              gap={1}
            >
              <Button
                size="small"
                type="submit"
                variant="contained"
                onClick={handleDownloadImageWrapper}
                sx={{ mb: 2 }}
              >
                ダウンロード
              </Button>
              <Button
                size="small"
                color="secondary"
                variant="outlined"
                onClick={() => onCancel()}
                sx={{ mb: 2 }}
              >
                もどる
              </Button>
            </Grid>
          ) : null}
        </BoxWrapper>
      </DialogContent>
    </Dialog>
  );
};

export default BaseDialog;
